import { render, staticRenderFns } from "./GruposView.vue?vue&type=template&id=c54b2184"
import script from "./GruposView.vue?vue&type=script&lang=js"
export * from "./GruposView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports